<template>
  <el-link :href="link" :target="target" type="info" :underline="false"><i :class="icon"></i>{{ text }}</el-link>
</template>

<script>
export default {
  name: 'Label',
  props: {
    link: String,
    text: String,
    target: String,
    icon: String
  }
}
</script>

<style lang="scss">
a {
    margin: 0px;
    background-color: $--color-background;
}
</style>
